export default __webpack_public_path__ + "static/media/calendar.703903e1.svg";